import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { NotificationAction } from '../../../app/common/notifications/notificationsActionType';
import { UpdatePasswordActions } from './updatePasswordActions';
import { UpdatePasswordAction } from './updatePasswordActionType';
import {
    IUpdatePasswordFormDispatchProps,
    IUpdatePasswordFormStateProps,
    UpdatePasswordForm,
} from './UpdatePasswordForm';
import { IUpdatePasswordRequest } from './updatePasswordRequest';
import { ErrorBoxActions } from '../../../app/common/errorBox/errorBoxActions';
import { ErrorBoxAction } from '../../../app/common/errorBox/errorBoxActionType';

function mapStateToProps(state: IReduxRootState) {
    const {
        app: {
            presentationConfig: {
                visibleFields: { account },
            },
        },
    } = state;
    const newPasswordValidatorRules = account.newPassword.validatorRules;
    return {
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.ACCOUNT_SECURITY
            : '',
        clientId: state.app.clientConfig ? state.app.clientConfig.clientId : undefined,
        isSubmitting: state.accountSecurity.updatingPassword,
        member: state.member,
        newPasswordValidatorRules: newPasswordValidatorRules,
        errorBoxMessage: state.errorBoxMessage.errorBoxMessage,
    };
}

function mapDispatchToProps(
    dispatch: ThunkDispatch<IReduxRootState, {}, UpdatePasswordAction | ErrorBoxAction>,
) {
    return {
        updatePassword: (data: IUpdatePasswordRequest) => {
            dispatch(UpdatePasswordActions.updateMemberPassword(data));
        },
        hideBox: () => {
            dispatch(ErrorBoxActions.hideBox());
        },
    };
}

const UpdatePasswordFormContainer = connect<
    IUpdatePasswordFormStateProps,
    IUpdatePasswordFormDispatchProps,
    {},
    IReduxRootState
>(
    mapStateToProps,
    mapDispatchToProps,
)(UpdatePasswordForm);

export default UpdatePasswordFormContainer;
